"use client";

import Link from "next/link";
import { Icon } from "@repo/ui/icon";
import Image from "next/image";
import LanguageSwitcher from "../language-switcher/LanguageSwitcher";
import React, { useState } from "react";
import MenuOverlay from "../menu-overlay/MenuOverlay";
import CookiesConsent from "../cookies-consent/CookiesConsent"; // <-- Import menu overlay

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <header className="w-full py-6 sticky top-0 left-0 right-0 bg-white z-30">
        <div className="max-w-7xl mx-auto flex flex-row justify-between gap-4 items-center">
          {/* Logo */}
          <Link href="/" className="flex flex-row gap-6 items-center relative">
            <Image
              width={53}
              height={21}
              className="invert sm:block hidden"
              src="/assets/lms-logo-invert.svg"
              alt="La maison Suisse Logo"
            />
            <span className="md:h-8 h-5 w-px bg-gray-300 sm:block hidden"></span>
            <Image
              width={105}
              height={22}
              className="md:w-[105px] sm:w-[100px] w-[120px]"
              src="/assets/littau.svg"
              alt="Lucerne Logo"
              style={{
                width: "105px",
                height: "22px",
              }}
            />
          </Link>

          {/* Desktop nav - hidden on mobile */}
          <ul className="hidden xl:flex flex-row xl:gap-8 gap-5 text-xs lg:text-sm uppercase">
            <li>
              <Link
                className="hover:underline underline-offset-2"
                href="/rooms"
              >
                STAY
              </Link>
            </li>
            <li>
              <Link
                className="hover:underline underline-offset-2"
                href="/#your-swiss-escape"
              >
                Activities
              </Link>
            </li>
            <li>
              <Link
                className="hover:underline underline-offset-2"
                href="/#elevated-experiences-at-lucerne"
              >
                Highlights
              </Link>
            </li>
            <li>
              <a
                target="_blank"
                href="https://lmsgroup.ch/"
                rel="noopener noreferrer"
                className="flex flex-row gap-0.5 items-center hover:underline underline-offset-2"
              >
                LMS
                <Icon size={16} name="arrow-up-right" />
              </a>
            </li>
          </ul>

          {/* Right controls */}
          <div className="flex flex-row gap-3 items-center xl:hidden">
            {/* Hamburger menu button - visible only on mobile */}
            <button
              type="button"
              aria-controls="preintro-menu"
              aria-expanded={menuOpen}
              aria-label="Open menu"
              className="flex flex-col gap-2 cursor-pointer p-2 xl:hidden"
              onClick={() => setMenuOpen(true)}
            >
              <span className="w-9 h-0.5 bg-primary" />
              <span className="w-5 h-0.5 bg-primary ml-auto" />
            </button>
          </div>
        </div>
      </header>
      {/*<CookiesConsent />*/}

      {/* Overlay menu */}
      <MenuOverlay open={menuOpen} onClose={() => setMenuOpen(false)} />
    </>
  );
}
